import { render, staticRenderFns } from "./SectionTemplates.vue?vue&type=template&id=89677b1c&scoped=true&"
import script from "./SectionTemplates.vue?vue&type=script&lang=js&"
export * from "./SectionTemplates.vue?vue&type=script&lang=js&"
import style0 from "./SectionTemplates.vue?vue&type=style&index=0&id=89677b1c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89677b1c",
  null
  
)

export default component.exports